
import { Component, Vue } from "vue-property-decorator";
import { SessionManager } from "@/components/utils/utils";

import { namespace } from "vuex-class";   
import "@/store/modules/common";
const commonState = namespace("Common");

@Component
export default class NavigationTopbar extends Vue {
    
    @commonState.State
    public userName!: string;

    @commonState.State
    public userHasStatisticsAccess!: boolean;

    public logout() {
        SessionManager.logout(this.$store);
    }

    public viewStats() {
        this.$router.push({name: "statistics" })
    }

    public home() {
        //console.log(this.$route.name)
        if(this.$route.name != "dashboard")
            this.$router.push({name: "dashboard" }) 
    }

}
